// extracted by mini-css-extract-plugin
export default {"wrap":"CompletionTimeRange-module_wrap__IxQ1ez"};